// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_ZYrc5 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._iconToggleSwitch_WgcOx {
  color: var(--6bd152af);
  transition: color var(--animation-quick) ease;
}
._iconToggleSwitch_WgcOx svg {
  /* Unlike other icons, this icon is not a square */
  height: auto !important;
}
._iconToggleSwitch_WgcOx circle {
  cx: var(--16fd8ca9);
  transition: cx var(--animation-quick) ease;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcIconToggleSwitch-saytabt5.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;EACE,kDAAkD;EAClD,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_ZYrc5 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._iconToggleSwitch_WgcOx {\n  color: var(--6bd152af);\n  transition: color var(--animation-quick) ease;\n}\n._iconToggleSwitch_WgcOx svg {\n  /* Unlike other icons, this icon is not a square */\n  height: auto !important;\n}\n._iconToggleSwitch_WgcOx circle {\n  cx: var(--16fd8ca9);\n  transition: cx var(--animation-quick) ease;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
